import React from "react";
import styles from "./HomeBoxes.module.css";
import {Link} from "react-router-dom";

const ExerciseBoxes = () => (
    <div className={styles.box_wrapper}>
        <div className={styles.box_row}>
            <div className={[styles.purple_box, styles.box].join(' ')}>
                <div className={styles.box_title}>
                    Matrix Properties
                </div>
                <div className={[styles.box_separator, styles.purple_separator].join(' ')}/>
                Calculate the <b>determinant</b>, <b>eigenvectors</b> and <b>eigenvalues</b> and more of 3x3 matrices.<br/><br/>
                <Link to="/matrix-properties/" style={{
                    display: 'inline', paddingLeft: '15px',
                    paddingRight: '15px', textDecoration: 'none', color: 'white', fontWeight: 'bold'
                }}>Click to continue -></Link>
            </div>
            <div className={[styles.green_box, styles.box].join(' ')}>
                <div className={styles.box_title}>
                    Matrix Operations
                </div>
                <div className={[styles.box_separator, styles.green_separator].join(' ')}/>
                Perform operations such as <b>addition</b>, <b>subtraction</b> or <b>multiplication</b> on 3x3 matrices.<br/><br/>
                <Link to="/matrix-operations/" style={{
                    display: 'inline', paddingLeft: '15px',
                    paddingRight: '15px', textDecoration: 'none', color: 'white', fontWeight: 'bold'
                }}>Click to continue -></Link>
            </div>
        </div>
        <div className={[styles.orange_box, styles.box].join(' ')}>
            <div className={styles.box_title}>
                Exercises
            </div>
            <div className={[styles.box_separator, styles.orange_separator].join(' ')}/>
            Solve matrix exercises uploaded by your teachers to <b>best prepare</b> for your <b>next
            exams</b>.<br/><br/>

            Logged in as a teacher you can also <b>add new exercises</b>.<br/><br/>
            <Link to="/exercises/" style={{
                display: 'inline', paddingLeft: '15px',
                paddingRight: '15px', textDecoration: 'none', color: '#5D5E5D', fontWeight: 'bold'
            }}>Click to continue -></Link>
        </div>
    </div>
);

export default ExerciseBoxes;